var React = require('react');

function RectangleInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("radialGradient",{"id":"radial-gradient","cx":"0.614","cy":"0.624","r":"0.5","gradientUnits":"objectBoundingBox"},[React.createElement("stop",{"offset":"0","stopColor":"#db3594","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#ba2b7d","key":1})])),React.createElement("rect",{"id":"Rectangle_1159","data-name":"Rectangle 1159","width":"118","height":"118","rx":"16","fill":"url(#radial-gradient)","key":1})]);
}

RectangleInline.defaultProps = {"width":"118","height":"118","viewBox":"0 0 118 118"};

module.exports = RectangleInline;

RectangleInline.default = RectangleInline;
